import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  type GetEntityNames200Response,
  useApi,
  EntityNamesFilteringDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type UseInfiniteIssueEntityNamesParamsObject = {
  page?: number;
  limit?: number;
  filter?: EntityNamesFilteringDtoOptions;
};

export interface UseInfiniteIssueEntityNamesParams {
  params?: UseInfiniteIssueEntityNamesParamsObject;
  enabled?: boolean;
}

export function useInfiniteIssueEntityNames({
  params = {},
  enabled = true,
}: UseInfiniteIssueEntityNamesParams) {
  const { page = 0, limit = 10, filter } = params;

  const api = useApi();

  const queryKey = ['entity-names', page, limit, filter, enabled];

  return useInfiniteQuery<
    GetEntityNames200Response,
    ExtendedAxiosError,
    InfiniteData<GetEntityNames200Response>,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      api.issueEntityNamesApi
        .getEntityNames(filter, pageParam, limit)
        .then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
  });
}
